import { render } from "./ChannelConfig.vue?vue&type=template&id=2e414c2e&scoped=true"
import script from "./ChannelConfig.vue?vue&type=script&lang=js"
export * from "./ChannelConfig.vue?vue&type=script&lang=js"

import "./ChannelConfig.vue?vue&type=style&index=0&id=2e414c2e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e414c2e"]])

export default __exports__